module.exports = __webpack_public_path__ + "img/1014.73ebd82f.png";